module.exports = __webpack_public_path__ + "static/media/ilkley-37.80c31f3f.jpg";